// libs
import React, { Fragment, memo } from 'react';

// styled components
import { Container, StyledProductPlaceholder } from './styles';

// constants
import {
  CAROUSEL_NAV_PADDING,
  DESKTOP_CAROUSEL_PROPS,
  DESKTOP_CAROUSEL_SLIDE_MARGIN,
} from 'shared/layouts/DetailsPage/components/Widgets/components/WidgetCarousel/helpers';

const PRODUCTS = [1, 2, 3, 4];
const ROWS = [1, 2, 3, 4];

interface IWidgetPlaceholderProps {
  isMobile?: boolean;
}

function WidgetPlaceholder({ isMobile = false }: IWidgetPlaceholderProps) {
  const desktopContainerStyle = isMobile
    ? undefined
    : { padding: `0 ${CAROUSEL_NAV_PADDING}px` };

  const desktopCardStyle = isMobile
    ? undefined
    : {
        width: DESKTOP_CAROUSEL_PROPS.slideWidth,
        height: DESKTOP_CAROUSEL_PROPS.slideHeight,
        marginRight: DESKTOP_CAROUSEL_SLIDE_MARGIN,
        flexShrink: 0 as const,
      };

  return (
    <Container>
      {ROWS.map((_, rIdx) => (
        <Fragment key={`widget-placeholder-row-${rIdx}`}>
          <div className="title" />
          <div className="container" style={desktopContainerStyle}>
            <div className="content">
              {PRODUCTS.map((__, idx) =>
                isMobile ? (
                  <StyledProductPlaceholder key={`widget-placeholder-product-${idx}`} />
                ) : (
                  <div key={`widget-placeholder-product-${idx}`} style={desktopCardStyle}>
                    <StyledProductPlaceholder />
                  </div>
                )
              )}
            </div>
          </div>
        </Fragment>
      ))}
    </Container>
  );
}

export default memo(WidgetPlaceholder);
